import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { config } from 'lib/config'
import { store } from 'lib/store'
import type { Place } from 'types/place'

export function usePlace(id: string | null, options?: SWRConfiguration) {
	const { data, mutate, isLoading, error } = useSWR<Place>(id ? `${config.apiURL}/v1.0/places/${id}` : null, options)

	if (error) {
		const isEmptyRatingError = error.data.statusCode === 400 && error.data.message.includes('rating')
		store.dispatch({
			type: 'toast/set',
			payload: {
				kind: 'error',
				timeout: 6000,
				message: isEmptyRatingError ? 'This place has no reviews' : 'Something went wrong',
			},
		})
	}

	return {
		place: data,
		mutatePlace: mutate,
		isPlaceLoading: isLoading,
	}
}
